// extracted by mini-css-extract-plugin
module.exports = {"background":"big-loader_background__1k0fp","loader":"big-loader_loader__3zQPB","bigLoaderText":"big-loader_bigLoaderText__3fSMN"};